module.exports = __webpack_public_path__ + "media/src/public/img/confirm-04c4653ec1b5e543cf25791dd7bd3d76.svg";